import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const AddUserIcon = forwardRef<SVGSVGElement, IconProps>(function AddUserIcon(
  { color = '', height = 24, width = 24, ...props },
  ref,
) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.5511 18.4153C13.5511 18.0654 13.8227 17.7818 14.1577 17.7818H17.3933C17.7284 17.7818 18 18.0654 18 18.4153C18 18.7652 17.7284 19.0488 17.3933 19.0488H14.1577C13.8227 19.0488 13.5511 18.7652 13.5511 18.4153Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.7755 16.0924C16.1106 16.0924 16.3822 16.3761 16.3822 16.726V20.1046C16.3822 20.4545 16.1106 20.7382 15.7755 20.7382C15.4405 20.7382 15.1689 20.4545 15.1689 20.1046V16.726C15.1689 16.3761 15.4405 16.0924 15.7755 16.0924Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1274 4.26701C10.4802 4.26701 9.14394 5.66421 9.15065 7.38127L9.15066 7.38386C9.15066 9.05886 10.4037 10.4179 11.9858 10.4913C12.0817 10.4843 12.183 10.484 12.2786 10.4912C13.853 10.4169 15.1122 9.05727 15.1122 7.38386C15.1122 5.66428 13.7741 4.26701 12.1274 4.26701ZM7.93731 7.38515C7.92852 4.9639 9.81144 3 12.1274 3C14.4443 3 16.3256 4.96453 16.3256 7.38386C16.3256 9.7528 14.5292 11.6798 12.2854 11.7589C12.2584 11.7599 12.2314 11.7589 12.2045 11.7561C12.1655 11.7521 12.1073 11.7515 12.0529 11.7567C12.0279 11.759 12.0027 11.7598 11.9776 11.7589C9.72506 11.6798 7.93796 9.7525 7.93731 7.38515Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.1234 13.7105C10.7475 13.7105 9.40373 14.0764 8.41219 14.7691L8.41086 14.7701C7.55875 15.362 7.21335 16.0802 7.21335 16.7186C7.21335 17.3572 7.55907 18.0778 8.41184 18.6741C9.40806 19.3674 10.7482 19.733 12.1274 19.733C12.4625 19.733 12.7341 20.0166 12.7341 20.3665C12.7341 20.7164 12.4625 21 12.1274 21C10.5625 21 8.97459 20.5886 7.7383 19.728L7.73734 19.7273C6.63292 18.9553 6 17.8769 6 16.7186C6 15.5601 6.63311 14.4835 7.73812 13.7156C8.97096 12.8545 10.5632 12.4435 12.1234 12.4435C13.6838 12.4435 15.2763 12.8547 16.5093 13.7161C16.7877 13.9107 16.8624 14.3041 16.6761 14.5949C16.4898 14.8857 16.113 14.9637 15.8345 14.7691C14.843 14.0764 13.4992 13.7105 12.1234 13.7105Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
